<template>
  <v-app-bar
    v-scroll="onScroll"
    flat
    app
  >
    <v-slide-x-transition>
      <v-img
        v-if="showLogo"
        :src="require('@/assets/logo.png')"
        class="shrink"
        contain
        height="50"
      />
    </v-slide-x-transition>
    <v-btn
      class="ml-3"
      large
      text
      to="Bridge"
    >
      Bridges
      <v-icon
        class="pl-3 pr-3"
        right
        large
      >
        mdi-bridge
      </v-icon>
    </v-btn>
    <v-spacer />
    <v-btn
      v-if="checkAdmin"
      class="ml-3"
      large
      text
      to="UserManagement"
    >
      User Management
      <v-icon
        class="pl-3"
        right
        large
      >
        mdi-account-group
      </v-icon>
    </v-btn>
    <v-btn
      v-if="!isLoggedIn"
      class="ml-3"
      large
      text
      to="login"
    >
      Login
      <v-icon
        right
        small
      >
        mdi-login-variant
      </v-icon>
    </v-btn>
    <v-btn
      v-else
      class="ml-3"
      large
      text
      to="logout"
    >
      Logout
      <v-icon
        right
        small
      >
        mdi-login-variant
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  export default {
    name: 'CoreAppBar',

    components: {
    },

    data: () => ({
      showLogo: false,
      isScrolling: false,
    }),

    methods: {
      onScroll () {
        const offset = window.pageYOffset
        this.isScrolling = offset > 50
        this.showLogo = offset > 200
      },
    },

    computed: {
      isLoggedIn() {
        return this.$store.getters['auth/isLoggedIn']
      },
      checkAdmin() {
        if(this.$store.getters['auth/getPermissions'])
          return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
        return false
      },

    }
  }
</script>